import styled, { css } from 'styled-components';

import Button from 'components/Button';

import useIsolateNav from 'hooks/useIsolateNav';
import useInView from 'hooks/useInView';

import { DotsPattern } from 'styles/global';
import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import TYPO, { H2 } from 'styles/typography';

const Section = styled.section`
  min-height: 320px;
  background-color: ${({ bgColor }) => bgColor || COLORS.forest};

  ${({ bgImg }) =>
    bgImg
      ? css`
          background: url(${bgImg.mobile}) no-repeat top center;
          background-size: cover;

          ${BREAKPOINTS.small`
            background-image: url(${bgImg.url});
          `}
        `
      : DotsPattern}

  ${BREAKPOINTS.small`
    min-height: 510px;
  `}
`;

const Content = styled.div`
  padding: 48px var(--gutter-side);
  min-height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${COLORS.pink};

  ${({ hasBgImg }) =>
    hasBgImg && `background-color: ${COLORS.black.opacity(0.2)}`};
`;

const Subtitle = styled.h6`
  ${TYPO.p3}
  margin-bottom: 10px;
  opacity: 0.7;

  ${BREAKPOINTS.small`
    margin-bottom: 18px;
  `}
`;

const ButtonStyled = styled(Button)`
  margin-top: 20px;

  ${BREAKPOINTS.small`
    margin-top: 40px;
  `}
`;

const HeroSection = ({ title, subtitle, cta, bgImg, bgColor, className }) => {
  const [inViewRef, inView] = useInView(false);

  useIsolateNav(inView);
  return (
    <Section ref={inViewRef} bgColor={bgColor} bgImg={bgImg}>
      <Content hasBgImg={bgImg} className={className}>
        <Subtitle as="h1">{subtitle}</Subtitle>
        <H2>{title}</H2>
        {cta && <ButtonStyled href={cta.link}>{cta.label}</ButtonStyled>}
      </Content>
    </Section>
  );
};

export default HeroSection;
